import { appLocale } from '@deepcloud/deep-ui-kit';
import { createGlobalState } from '@vueuse/core';
import { watch } from 'vue';
import AuthService from '@/services/authService.ts';
import deepSignApi from '@/api/deepsign/deepsignApi';
import { getIsoCodeByLanguage } from '@/composables/useUtils';

export const SUPPORTED_LOCALES = ['de', 'en', 'fr', 'it'];

export const useAppLocale = createGlobalState(() => {
  const { locale, changeLocale, setLocale } = appLocale({
    supportedLocales: SUPPORTED_LOCALES,
    fallbackLocale: 'en',
    storageKey: 'storedAppLocale',
    initialLocale: () => AuthService.userLang ?? undefined,
    persist: {
      enabled: () => !!AuthService.isAuthenticated,
      apiToken: () => AuthService.fullAccessToken ?? '',
      env: () => import.meta.env.VITE_ENVIRONMENT,
      userId: () => AuthService.user?.sub,
      afterPersist: () => AuthService.updateToken(-1)
    }
  });

  // appLocale() doesn't manage this legacy raw-axios instance's headers.
  watch(
    locale,
    (newLocale) => {
      deepSignApi.defaults.headers.common['Accept-Language'] =
        getIsoCodeByLanguage(newLocale);
    },
    { immediate: true }
  );

  return { locale, changeLocale, setLocale };
});
